// Customer-comp.js
import React, { useState } from "react";
import { getUser } from "./service/AuthService";
import { useNavigate } from "react-router-dom";
import TopCards from "./components/dashboard/TopCards";
import Cards from "./components/dashboard/Cards";
import "./styles/Customer.scss";
import "./dist/css/style.min.css";

const CustomerPortal = () => {
  const user = getUser();
  const name = user !== "undefined" && user ? user.name : "";
  const username = user !== "undefined" && user ? user.username : "";
  const organization = user !== "undefined" && user ? user.organization : "";
  const subscriptions = user !== "undefined" && user ? user.subscriptions : "";
  const subscriptionList = subscriptions ? subscriptions.split(",") : [];
  const navigate = useNavigate();

  const [frmLoad, setFrmLoad] = useState("customer");

  // Credits and expiry pulled by TopCards
  const [creditsBalance, setCreditsBalance] = useState(0);
  const [expiryDate, setExpiryDate] = useState("");

  const formattedName =
    name && name.length > 0
      ? name.charAt(0).toUpperCase() + name.slice(1)
      : "";

  const formSwitcher = (frmType) => {
    if (frmType === "modelbuilder") {
      navigate("/modelbuilder");
    } else if (frmType === "vendorpricetable") {
      navigate("/vendorpricetable");
    }
  };

  // const handleManageCredits = () => {
  //   navigate("/manageusercredits");
  // };

  return (
    <div className="customer-page">
      <div className="row" style={{ justifyContent: "space-between" }}>
        <span className="font-md-lg" align="center">
          Hello <span className="font-bold font-md-lg">{formattedName}!</span>
          &nbsp;Welcome to your personalized dashboard.
        </span>
      </div>

      <br />
      {/* Pass a callback to receive balance & expiry from TopCards */}
      <TopCards
        onBalanceLoaded={(bal, exp) => {
          setCreditsBalance(bal);
          setExpiryDate(exp);
        }}
      />
      <br />
      <br />

      <Cards creditsAvailable={creditsBalance} expiryDate={expiryDate} />
      <br />

      {frmLoad === "customer" && (
        <CustomerPortalContent formSwitcher={formSwitcher} />
      )}
      <br />
    </div>
  );
};

// Placeholder separate inner portal section for later use
const CustomerPortalContent = ({ formSwitcher }) => {
  return <></>;
};

export default CustomerPortal;
